/** Módulos alineados con backend/permissions.py */
export const MODULES = [
  { id: "dashboard", label: "Resumen / dashboard", group: "General" },
  { id: "plan_cuentas", label: "Plan de cuentas", group: "Contabilidad" },
  { id: "libro_diario", label: "Libro diario", group: "Contabilidad" },
  { id: "libro_mayor", label: "Libro mayor", group: "Contabilidad" },
  { id: "reportes", label: "Reportes", group: "Reportes" },
  { id: "comercial", label: "Comercial", group: "Comercial" },
  { id: "facturador", label: "Facturador electrónico (DTE)", group: "Comercial" },
  { id: "tesoreria", label: "Tesorería", group: "Tesorería" },
  { id: "empresas", label: "Empresas / RUT", group: "Administración" },
  { id: "usuarios", label: "Usuarios", group: "Administración" },
  { id: "remuneraciones", label: "Remuneraciones", group: "Remuneraciones" },
];

export const LEVEL_OPTIONS = [
  { value: "none", label: "Sin acceso" },
  { value: "read", label: "Solo ver" },
  { value: "write", label: "Ver y editar" },
];

export function defaultPermissionsForRole(role) {
  const all = Object.fromEntries(MODULES.map((m) => [m.id, "write"]));
  if (role === "owner") return all;
  if (role === "contador") {
    return { ...all, usuarios: "none", empresas: "read", remuneraciones: "write" };
  }
  if (role === "usuario") {
    return {
      dashboard: "read",
      plan_cuentas: "read",
      libro_diario: "write",
      libro_mayor: "read",
      reportes: "read",
      comercial: "write",
      facturador: "write",
      tesoreria: "read",
      empresas: "read",
      usuarios: "none",
      remuneraciones: "none",
    };
  }
  return Object.fromEntries(MODULES.map((m) => [m.id, "read"]));
}

const RANK = { none: 0, read: 1, write: 2 };

export function levelForUser(user, moduleId) {
  if (!user || user.solo_lectura) {
    return moduleId ? "read" : "none";
  }
  if (user.role === "superadmin" || user.role === "owner") return "write";
  const modulos = user.permisos?.modulos || {};
  return modulos[moduleId] || defaultPermissionsForRole(user.role)[moduleId] || "none";
}

export function canRead(user, moduleId) {
  return RANK[levelForUser(user, moduleId)] >= RANK.read;
}

export function canWrite(user, moduleId) {
  if (user?.solo_lectura) return false;
  return RANK[levelForUser(user, moduleId)] >= RANK.write;
}
